import React, { useEffect, useState } from "react";
import axios from "../../../lib/axios";
import "./AdGroup.scss";

import { Delete } from "@mui/icons-material";
import TechAddLesson from "./AdminAddGroup";
import TechUpdateLesson from "./AdminUpdateGroup";
import AdNavbar from "../AdNavbar/AdNavbar";
import { Link } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

export default function AdGroup() {
  const useAuth = window.localStorage;
  const Token = useAuth.getItem("accessToken");
  const [groups, setGroups] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit] = useState(10);

  const config = {
    headers: {
      Authorization: Token,
    },
  };

  useEffect(() => {
    axios
      .get(`groups?page=${page}&limit=${limit}`, config)
      .then((response) => {
        console.log(response.data);
        setGroups(response.data.groups || []);
        setTotalPages(
          response.data.count < limit ? 1 : Math.ceil(response.data.count / limit)
        );
      })
      .catch((err) => {
        console.log(err);
        setGroups([]); // Xato bo'lsa, groups ni bo'sh arrayga tenglash
      });
  }, [page]);

  const deleteLesson = (id) => {
    if (confirm("O'chirishni istaysizmi?")) {
      axios
        .delete(`group/${id}`, config)
        .then(() => {
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const toggleAction = (e) => {
    const actionBody = e.target.nextSibling;
    if (actionBody.style.display === "block") {
      actionBody.style.display = "none";
    } else {
      actionBody.style.display = "block";
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const setGroupId = (id) => {
    localStorage.setItem("groupId", id);
  };

  return (
    <>
      <AdNavbar />
      <main className="mainPage">
        <section className="mygroup-section tech-lesson-section admin-group-section ad-teacher">
          <div className="container">
            <div className="mygroup">
              <table className="mygroup__table desktop">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Guruh nomi</th>
                    <th>Narxi</th>
                    <th className="add-wrapper">
                      <TechAddLesson />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {groups && groups.length > 0 ? (
                    groups.map((item, index) => (
                      <tr key={index} id={item.group_id}>
                        <td>{index + 1}</td>
                        <td id="lessonName">
                          <Link to={`/ad-groups-student/${item.group_id}`} onClick={() => setGroupId(item.group_id)}>
                            {item.name}
                          </Link>
                        </td>
                        <td>
                          <p>{item.price} so`m</p>
                        </td>
                        <td className="add-wrapper">
                          <TechUpdateLesson data={item} />
                          <button
                            className="btn-delete"
                            onClick={() => deleteLesson(item.group_id)}
                            style={{ color: "crimson" }}
                          >
                            <Delete />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" style={{ textAlign: "center" }}>
                        Ma`lumotlar mavjud emas
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="mygroup__table mobile">
                <div className="mygroup__table-head">
                  <div className="">#</div>
                  <div className="">Guruh nomi</div>
                  <TechAddLesson />
                </div>
                <div className="mygroup__table-body">
                  {groups && groups.length > 0 ? (
                    groups.map((item, index) => (
                      <div key={index} className="mygroup__table-body--item">
                        <div className=""><p>{index + 1}</p></div>
                        <div className="group-name">
                          <p>
                            <Link to={`/ad-groups/${item.group_id}`}>
                              {item.name}
                            </Link>
                          </p>
                        </div>
                        <div>
                          <button className="btn-action" onClick={toggleAction}>
                            •••
                          </button>
                          <div className="ad-teacher-action-body">
                            <TechUpdateLesson data={item} />
                            <button
                              className="btn-delete"
                              onClick={() => deleteLesson(item.group_id)}
                              style={{ color: "crimson" }}
                            >
                              <Delete />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div style={{ textAlign: "center", padding: "20px", width: "100%" }}>
                      Ma`lumotlar mavjud emas
                    </div>
                  )}
                </div>
              </div>
              <Stack spacing={2} alignItems="center" marginTop="20px">
                <Pagination
                  count={totalPages}
                  page={page}
                  onChange={handlePageChange}
                  color="secondary"
                  variant="outlined"
                  shape="rounded"
                />
              </Stack>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
